import { phoneAuthAdminQueryKeys as e } from "./phoneAuthAdminQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminPhoneAuthApi as n } from "@maat/api-main";
//#region src/phoneAuth/admin/usePhoneAuthHealthQuery.ts
var r = () => t({
	queryKey: e.health(),
	queryFn: () => n.health()
});
//#endregion
export { r as usePhoneAuthHealthQuery };
